import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  TextField,
  MenuItem,
  ListItemText,
  IconButton,
  Paper,
  CircularProgress,
} from '@mui/material';
import InputField from '../formElements/InputField';
import SelectField from '../formElements/SelectField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CalendarToday, Close, Height } from '@mui/icons-material';
import ErrorIcon from '@mui/icons-material/Error';
import { API, graphqlOperation } from 'aws-amplify';
import {
  createAddressEntity,
  createNumberTracker,
  createCompanyDetails,
  createCompanyEntity,
  createFinancialYear,
  createUserPreference,
  createCompanyFY,
  createInvoiceSettings,
  createPOSInvoiceSettings,
  createPaymentSettings,
  createPhoneContacts,
  createEmailContacts,
} from '../../graphql/mutations';
import { getCodeTranslation, listFinancialYear, listUserPreference } from '../../graphql/queries';
import { useDispatch, useSelector } from 'react-redux';
import { skipFalse, skipOpen } from '../../redux/reducers/companySkip';
import { LoadingButton } from '@mui/lab';
import dayjs from 'dayjs';
import { skipNotSave, skipSave } from '../../redux/reducers/companySkipSave';
import { showWarningSnackbar, showSuccessSnackbar, showErrorSnackbar } from '../snackBar/snakbar';
import CustomPhoneInputBox from '../customInputBox/CustomPhoneInputBox';
import { useNavigate } from 'react-router-dom';
import { setCompanyName } from '../../redux/reducers/CompanySlice';
import { fetchCompany } from '../../redux/reducers/CompanySlice.js';
import { fetchPaymentSettings } from '../../redux/reducers/PaymentSettingsSlice.js';
import { fetchInvoiceSettings } from '../../redux/reducers/InvoiceSettings.js';
import { getAccessToken, getUserAttributes } from '../../library/shared.js';
import { matchIsValidTel } from 'mui-tel-input';
import { FetchGstInDetails } from '../../library/GstinFetch.js';
import moment from 'moment';
import { useThemes } from '../Theme/theme.js';
import { lowercaseKeys } from '../../utils/common.js';
import { createCompanyFYv2 } from '../../graphql';
import { GuidedNav } from './GuidedTourComponent.jsx';
import useControlledNavigation from '../../hooks/useControlledNavigation.js';
import { OpeningBalanceDateApi } from '../../redux/apis/openingbalacedate.api';
import { setIsAnyModalOpen } from '../../redux/reducers/controllNavigation';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  // p: 4,
  outline: 'none',
  '@media (min-width:600px)': {
    width: 'auto',
  },
  width: '90%',
};

let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();
const prevYear = new Date(yy - 1, mm, dd);
if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;
const endFyDate = yy + '-' + '03' + '-' + '31';
let currentDate = '';

// Order of form fields for focusing first error (must match errorStatus keys)
const ERROR_FIELD_FOCUS_ORDER = [
  'gstCategory',
  'gstin',
  'legalname',
  'mobile',
  'fromDate',
  'startendmonth',
  'fyStatrt',
  'fyEnd',
  'selectedFy',
];
const GSTIN_FORMAT_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z\d]{2}[1-9A-Z]{1}[0-9A-Z]{1}$/;
/** GSTIN mandatory for these categories (same rules for Registered and Composition). */
const GST_CATEGORIES_REQUIRING_GSTIN = ['Registered', 'Composition'];
const FIELD_FOCUS_ID_MAP = {
  gstCategory: 'gstCategory',
  gstin: 'field-gstin',
  legalname: 'companyName',
  mobile: 'MuiTelInput',
  fromDate: 'field-fromDate',
  startendmonth: 'finantialYear',
  fyStatrt: 'field-fYStart',
  fyEnd: 'field-fYEnd',
  selectedFy: 'finantialYear',
};
function focusFirstErrorField(firstErrorFieldKey) {
  const id = FIELD_FOCUS_ID_MAP[firstErrorFieldKey];
  if (!id) return;
  const el = document.getElementById(id) || document.querySelector(`[name="${firstErrorFieldKey}"]`);
  if (!el) return;
  if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') {
    el.focus();
  } else {
    const input = el.querySelector?.('input, [role="combobox"], [role="button"]');
    (input || el).focus?.();
  }
}
if (today <= new Date(endFyDate)) {
  currentDate = prevYear;
} else {
  currentDate = todayDate;
}
const finacialYearsOptions = [
  { option: '01 Jan - 31 Dec', value: '01 Jan - 31 Dec' },
  // { option: "01 Feb - 31 Jan", value: "01 Feb - 31 Jan" },
  // { option: "01 Mar - 28 Feb", value: "01 Mar - 28 Feb" },
  { option: '01 Apr - 31 Mar', value: '01 Apr - 31 Mar' },
  // { option: "01 May - 30 Apr", value: "01 May - 30 Apr" },
  // { option: "01 Jun - 31 May", value: "01 Jun - 31 May" },
  // { option: "01 Jul - 30 Jun", value: "01 Jul - 30 Jun" },
  // { option: "01 Aug - 31 Jul", value: "01 Aug - 31 Jul" },
  // { option: "01 Sep - 31 Aug", value: "01 Sep - 31 Aug" },
  // { option: "01 Oct - 30 Sep", value: "01 Oct - 30 Sep" },
  // { option: "01 Nov - 31 Oct", value: "01 Nov - 31 Oct" },
  // { option: "01 Dec - 30 Nov", value: "01 Dec - 30 Nov" },
];

const CompanySetupSkip = ({ children, newCompanyCreation, setOpenSkipModal, resFn }) => {
  const { theme } = useThemes();
  const { skipStatus } = useSelector((state) => state.companySkipReducer);
  const phone_number = useSelector((state) => state?.userDetailsReducer?.userDetails?.phone_number);
  const { companyList, Loaded: companyLoaded, companyDetails: companyDetailsData } = useSelector((state) => state?.companyReducer);

  const controlNavigateState = useSelector((state) => state?.controllNavigationSlice);
  const dispatch = useDispatch();
  const navigate = useControlledNavigation();
  const [open, setOpen] = useState(false);
  const [countries, SetCountries] = useState('');
  const [startEndYearValue, setStartEndYearValue] = useState('');
  const childRef = useRef(null);
  const companyCreateInFlightRef = useRef(false);
  const [freezeInput, setFreezeInput] = useState(false);

  // console.log(companyDetailsData);
  const [skipformElements, setSkipFormElements] = useState({
    gstCategory: '',
    gstin: '',
    pan: '',
    entityTYpe: '',
    legalname: '',
    state: '',
    country: '',
    city: '',
    address: '',
    fromDate: todayDate,
    startendmonth: '01 Apr - 31 Mar',
    fyStart: dayjs(currentDate),
    fyEnd: dayjs(currentDate).add(1, 'year'),
    selectedFy: '01 Apr' + ' ' + dayjs(currentDate).$y + ' ' + 'to' + ' ' + '31 Mar' + ' ' + dayjs(currentDate).add(1, 'year').$y,
    mobile: '',
    EInvoiceFlag: 0,
    errorStatus: {
      gstCategory: false,
      gstin: false,
      entityTYpe: false,
      legalname: false,
      state: false,
      country: false,
      address: false,
      fromDate: false,
      startendmonth: false,
      fyStatrt: false,
      fyEnd: false,
      selectedFy: false,
      mobile: false,
    },
    errorFields: {
      gstCategory: '',
      gstin: '',
      entityTYpe: '',
      legalname: '',
      state: '',
      country: '',
      address: '',
      fromDate: '',
      startendmonth: '',
      fyStatrt: '',
      fyEnd: '',
      selectedFy: '',
      mobile: '',
    },
  });

  let check = async () => {
    try {
      let { phone_number: mobile } = await getUserAttributes();
      // Proceed with using mobile
      setSkipFormElements((prev) => ({
        ...prev,
        mobile,
      }));
    } catch (error) {
      console.error('Failed to retrieve user attributes:', error);
    }
  };

  useEffect(() => {
    check();
    return () => {};
  }, [companyDetailsData, phone_number]);

  const [formElements, setFormElements] = useState({
    stateArrayLists: [],
    districtArrayLists: [],
  });
  const [loading, setloading] = useState(false);
  const bottomNavPrevStyleRef = useRef(null);
  const [finId, setFinId] = useState();
  // const companyLoaded = useSelector((state) => state?.companyReducer.Loaded);

  useEffect(() => {
    const el = document.getElementById('bottom-navbar');
    if (!el) return;

    const shouldBlur = Boolean(loading);

    if (shouldBlur) {
      if (!bottomNavPrevStyleRef.current) {
        bottomNavPrevStyleRef.current = {
          filter: el.style.filter,
          opacity: el.style.opacity,
          pointerEvents: el.style.pointerEvents,
          transition: el.style.transition,
        };
      }
      el.style.transition = 'filter 120ms ease, opacity 120ms ease';
      el.style.filter = 'blur(6px)';
      el.style.opacity = '0.9';
      el.style.pointerEvents = 'none';
    } else if (bottomNavPrevStyleRef.current) {
      const prev = bottomNavPrevStyleRef.current;
      el.style.filter = prev.filter;
      el.style.opacity = prev.opacity;
      el.style.pointerEvents = prev.pointerEvents;
      el.style.transition = prev.transition;
      bottomNavPrevStyleRef.current = null;
    }

    return () => {
      const el2 = document.getElementById('bottom-navbar');
      if (el2 && bottomNavPrevStyleRef.current) {
        const prev = bottomNavPrevStyleRef.current;
        el2.style.filter = prev.filter;
        el2.style.opacity = prev.opacity;
        el2.style.pointerEvents = prev.pointerEvents;
        el2.style.transition = prev.transition;
        bottomNavPrevStyleRef.current = null;
      }
    };
  }, [loading]);

  useEffect(() => {
    // let skipstatus = localStorage.getItem("skipModalStatus");
    if (companyLoaded)
      if (skipStatus === true) {
        localStorage.setItem('tutorialStep', 0);
        setOpen(true);
      } else {
        setOpen(false);
      }
  }, [skipStatus, companyLoaded]);
  const fin = async () => {
    try {
      let financialYear = '';
      const res = await API.graphql(graphqlOperation(listUserPreference));
      setFinId(res?.data?.listUserPreference[0]?.AttributeValue);
    } catch (error) {
      console.log(error);
      // setOpen(true);
    }
  };
  useEffect(() => {
    if (newCompanyCreation) {
      localStorage.setItem('FirstTutorial', true);
      setOpen(true);
      console.log('jjjjjjjjjjjjjj');
    }
  }, []);
  useEffect(() => {
    if (open) {
      fin();
    }
  }, [open]);
  const setDefaultPaymentSettings = async (CompanyID) => {
    try {
      let financialYear = '';
      const res = await API.graphql(
        graphqlOperation(createPaymentSettings, {
          paymentSettingsInput: {
            CompanyID,
            Enable_AutoPayReminder: 0,
            Enable_AutoReminderDays: 0,
            Enable_CreditLimit: 1,
            Enable_CreditPeriod: 1,
            Enable_ItemWiseEntry: 1,
          },
        })
      );
      // console.log(res, "payment setting");
    } catch (error) {
      console.log(error);
    }
  };

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  async function createNewCompany(data, skip) {
    try {
      setloading(true);
      data = lowercaseKeys(data);
      const res = await API.graphql(graphqlOperation(createCompanyFYv2, { createCompanyFYInput: data }));
      setOpen(false);
      if (res.data.createCompanyFYv2.StatusCode != null) {
        showWarningSnackbar(`${res.data.createCompanyFYv2.StatusMessage}`);
      } else {
        // delay(2500);
        // dispatch(fetchPaymentSettings());
        dispatch(fetchInvoiceSettings());
        setTimeout(() => {
          if (newCompanyCreation) {
            if (!controlNavigateState?.isBlocked) navigate('/');
            setOpenSkipModal(false);
          } else {
            if (!controlNavigateState?.isBlocked) navigate('/companycreation?status=success');
          }
        }, 3500);
        showSuccessSnackbar('Company Created Successfully');
        dispatch(OpeningBalanceDateApi.util.invalidateTags([{ type: 'OpeningBalanceDateApi', id: 'ALL' }]));
        // const userEnteringCount = localStorage.getItem("firstTimeUser");
        if (companyList.length === 0) {
          setTimeout(() => {
            localStorage.setItem('firstNavigationCompleted', true);
            childRef.current.startGuidedNavigation();
          }, 4000);
        }
        if (resFn) resFn(res?.data?.createCompanyFYv2, data?.companyname, data?.startyear, data?.endyear);

        dispatch(setCompanyName(res?.data?.createCompanyFYv2?.relatedCompanyDetailsNew?.CompanyShort));

        dispatch(skipFalse());
        if (companyDetailsData === undefined || companyDetailsData === null) dispatch(fetchCompany());
      }
    } catch (error) {
      setOpen(true);
      console.log(error, 'error');

      if (error.errors) {
        if (error.errors[0]?.message.includes('Already Exists')) {
          const inputField = document.getElementById('companyName');
          if (inputField) {
            inputField.focus();
          }
          showErrorSnackbar('A company with this name already exists. Please try a different name or check the company list.');
        } else {
          showErrorSnackbar('An unexpected error occurred. Please try again later.');
        }
      }
    } finally {
      setFreezeInput(false);
      setOpenSkipModal?.(false);
      setloading(false);
    }
  }
  useEffect(() => {
    if (freezeInput) {
      // setOpen(false);
      setloading(true);
    } else {
      setloading(false);
    }
  }, [freezeInput]);
  console.log(freezeInput, 'freezeInput');

  async function listUserPreferenceDetails(companyID) {
    try {
      const res = await API.graphql(graphqlOperation(listUserPreference));
      let attributeValue = '';
      res?.data?.listUserPreference.map((ele) => {
        if (ele.AttributeTypeCD == 'SelectedFinYear') {
          attributeValue = ele.AttributeValue;
        }
      });
      await Promise.all(saveGeneralSettings(attributeValue, companyID));
    } catch (error) {
      console.log('error', error);
    }
  }
  async function addComapnyEntity(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(createCompanyEntity, {
          createCompanyEntityInput: data,
        })
      );
      console.log(res, 'entity');
      if (res.data.createCompanyEntity != null) {
        setOpen(false);
        setloading(false);
        dispatch(skipFalse());
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function addAddress(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(createAddressEntity, {
          createAddressEntityInput: data,
        })
      );
      // console.log(res.data);
    } catch (error) {
      console.log(error);
    }
  }

  async function addEmailContacts(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(createEmailContacts, {
          createEmailContactsInput: data,
        })
      );
      // console.log(res.data, "email input");
    } catch (error) {
      console.log(error);
    }
  }
  async function getCountries() {
    let code = 'Country';
    const cities = await API.graphql(graphqlOperation(getCodeTranslation, { CodeType: code }));
    if (cities?.data?.getCodeTranslation != null) {
      let countriesArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          option: element.CodeText,
          value: `${element.CodeText}State`,
        };
      });
      SetCountries(countriesArray);
    }
  }
  async function getStates(country) {
    try {
      const cities = await API.graphql(graphqlOperation(getCodeTranslation, { CodeType: country }));

      let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          option: element.CodeText,
          value: `${element.CodeText}District`,
        };
      });

      setFormElements((prev) => ({
        ...prev,
        stateArrayLists: statesArray,
      }));
    } catch (error) {}
  }

  const setDefaultInvoiceSettings = async (CompanyID) => {
    try {
      let RegularSettings = {
        CompanyID,
        CompanyName: 1,
        CompanyCIN: 1,
        InvoiceNumber: 1,
        CompanyAddress: 1,
        CompanyLogo: 1,
        InvoiceDate: 1,
        CompanyContactNumber: 1,
        CompanyEmail: 1,
        PaymentMode: 1,
        CompanyGSTIN: 1,
        CompanyWebsite: 1,
        CreditPeriod: 1,
        CompanyPAN: 1,
        CompanyBankDetails: 1,
        PaymentDueDate: 1,
        CustomerLegalName: 1,
        CustomerGSTIN: 1,
        LUTBondDetails: 1,
        CustomerDisplayName: 1,
        PlaceOfSupply: 1,
        DispatchDetails: 1,
        CustomerBillingAddress: 1,
        CustomerContactPerson: 1,
        EWayBillDetails: 1,
        CustomerShippingAddress: 1,
        CustomerOrderNoAndDate: 1,
        EInvoiceDetails: 1,
        ItemWiseDiscount: 1,
        HSNSACode: 1,
        ShowRoundOff: 1,
        HSNSASummaryTable: 1,
        InvoiceDescription: 1,
        TermsAndConditionsFlag: 1,
        DeclarationAtFooterFlag: 1,
        DeclarationAtFooter: '',
        TermsAndCondition: '',
        SignatureText: '',
        InvoiceHeading: '',
        RegularInvoiceSignatureFileName: '',
        DefaultSetting: 1,
      };
      let Regulardata = {
        EnteredTimeStamp: 0,
        ExpiredTimeStamp: 0,
        TypeCD: 'RegularSettings',
        CustomerContactNumber: 1,
        CustomerName: 1,
        ...RegularSettings,
        RegularInvoiceSignatureFileName: '',
      };
      // console.log(Regulardata);
      let result = await API.graphql(
        graphqlOperation(createInvoiceSettings, {
          invoiceSettingsInput: Regulardata,
        })
      );
      // console.log(result, "invoiceSettings");
      let PosSettings = {
        CompanyID,
        CompanyName: 1,
        CompanyCIN: 1,
        InvoiceNumber: 1,
        CompanyAddress: 1,
        CompanyLogo: 1,
        InvoiceDate: 1,
        CompanyContactNumber: 1,
        CompanyEmail: 1,
        PaymentMode: 1,
        CompanyGSTIN: 1,
        CompanyWebsite: 1,
        CreditPeriod: 1,
        CompanyPAN: 1,
        CompanyBankDetails: 1,
        PaymentDueDate: 1,
        CustomerLegalName: 1,
        CustomerGSTIN: 1,
        LUTBondDetails: 1,
        CustomerDisplayName: 1,
        PlaceOfSupply: 1,
        DispatchDetails: 1,
        CustomerBillingAddress: 1,
        CustomerContactPerson: 1,
        EWayBillDetails: 1,
        CustomerShippingAddress: 1,
        CustomerOrderNoAndDate: 1,
        EInvoiceDetails: 1,
        ItemWiseDiscount: 1,
        HSNSACode: 1,
        ShowRoundOff: 1,
        HSNSASummaryTable: 1,
        InvoiceDescription: 1,
        TermsAndConditionsFlag: 1,
        DeclarationAtFooterFlag: 1,
        CustomerContactNumber: 1,
        CustomerName: 1,
        DeclarationAtFooter: '',
        TermsAndCondition: '',
        SignatureText: '',
        InvoiceHeading: '',
        RegularInvoiceSignatureFileName: '',
        DefaultSetting: 1,
      };
      let Posdata = {
        EnteredTimeStamp: 0,
        ExpiredTimeStamp: 0,
        TypeCD: 'PosSettings',
        ...PosSettings,
        RegularInvoiceSignatureFileName: '',
      };
      // console.log(Regulardata);
      let resultPos = await API.graphql(
        graphqlOperation(createPOSInvoiceSettings, {
          invoiceSettingsInput: Posdata,
        })
      );
      // console.log(resultPos, "pos invoice");
    } catch (error) {
      console.log(error);
    }
  };

  const closeBookFYState = useSelector((state) => state?.closeBookFYStateReducer);
  const financialid = closeBookFYState?.currentFY?.FinancialYearID;
  // console.log(financialid, "financialid");

  async function saveGeneralSettings(fyID, companyID) {
    try {
      // console.log(fyID, "fyID");
      let endDate = '';
      let startDate = '';
      let SED = '';
      let FYID = '';
      let fYearData = {};
      SED = skipformElements.startendmonth.split(' ');
      startDate = new Date(SED[0] + '-' + SED[1] + '-' + new Date(skipformElements.fyStart).getFullYear());
      let syy = startDate.getFullYear();
      let smm = startDate.getMonth() + 1;
      let sdd = startDate.getDate();
      if (sdd < 10) sdd = '0' + sdd;
      if (smm < 10) smm = '0' + smm;
      let SD = syy + '-' + smm + '-' + sdd;
      endDate = new Date(SED[4] + '-' + SED[3] + '-' + new Date(skipformElements.fyEnd).getFullYear());
      let eyy = endDate.getFullYear();
      let emm = endDate.getMonth() + 1;
      let edd = endDate.getDate();
      if (edd < 10) edd = '0' + edd;
      if (smm < 10) emm = '0' + emm;
      let ED = eyy + '-' + emm + '-' + edd;

      const itemSettingsData = {
        EntryTypeCD: 'Item',
        FinancialYearID: fyID,
        SerialNumber: 'G',
        SerialIsActive: 1,
        CompanyID: companyID,
        NextInvoiceNumber: 1,
        Prefix: 'G',
        Suffix: '',
      };
      const resItemSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: itemSettingsData,
        })
      );

      const serviceSettingsData = {
        EntryTypeCD: 'Service',
        SerialNumber: 'S',
        SerialIsActive: 1,
        FinancialYearID: fyID,
        NextInvoiceNumber: 1,
        Prefix: 'S',
        Suffix: '',
        CompanyID: companyID,
      };
      const resServiceSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: serviceSettingsData,
        })
      );

      const salesSettingsData = {
        EntryTypeCD: 'SalesInvoice',
        SerialNumber: 'SINV',
        SerialIsActive: 1,
        FinancialYearID: fyID,
        NextInvoiceNumber: 1,
        Prefix: 'SINV',
        Suffix: '',
        CompanyID: companyID,
      };

      const resSalesSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: salesSettingsData,
        })
      );

      const salesBOSSettingsData = {
        EntryTypeCD: 'SalesInvoice',
        SerialNumber: 'BOS',
        SerialIsActive: 1,
        FinancialYearID: fyID,
        NextInvoiceNumber: 1,
        Prefix: 'BOS',
        Suffix: '',
        CompanyID: companyID,
      };

      const resSalesBOSSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: salesBOSSettingsData,
        })
      );

      const posSettingsData = {
        EntryTypeCD: 'PosInvoice',
        SerialNumber: 'POS',
        SerialIsActive: 1,
        NextInvoiceNumber: 1,
        FinancialYearID: fyID,
        Prefix: 'POS',
        Suffix: '',
        CompanyID: companyID,
      };

      const resPosSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: posSettingsData,
        })
      );

      const purchaseSettings = {
        EntryTypeCD: 'PurchaseInvoice',
        SerialNumber: 'PINV',
        SerialIsActive: 1,
        NextInvoiceNumber: 1,
        FinancialYearID: fyID,
        Prefix: 'PINV',
        Suffix: '',
        CompanyID: companyID,
      };
      const rePurchaseSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: purchaseSettings,
        })
      );

      const paymentSettings = {
        EntryTypeCD: 'Payment',
        SerialNumber: 'PYT',
        SerialIsActive: 1,
        NextInvoiceNumber: 1,
        FinancialYearID: fyID,
        Prefix: 'PYT',
        Suffix: '',
        CompanyID: companyID,
      };

      const resPaymentSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: paymentSettings,
        })
      );

      const receiptSettings = {
        EntryTypeCD: 'Receipt',
        SerialNumber: 'RECT',
        SerialIsActive: 1,
        NextInvoiceNumber: 1,
        FinancialYearID: fyID,
        Prefix: 'RECT',
        Suffix: '',
        CompanyID: companyID,
      };

      const resReceiptSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: receiptSettings,
        })
      );

      const journalSettings = {
        EntryTypeCD: 'Journal',
        SerialNumber: 'JV',
        SerialIsActive: 1,
        FinancialYearID: fyID,
        NextInvoiceNumber: 1,
        Prefix: 'JV',
        Suffix: '',
        CompanyID: companyID,
      };

      const resJournalSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: journalSettings,
        })
      );
      const creditSettingsData = {
        EntryTypeCD: 'CreditInvoice',
        SerialNumber: 'CDN',
        SerialIsActive: 1,
        NextInvoiceNumber: 1,
        FinancialYearID: fyID,
        Prefix: 'CDN',
        Suffix: '',
        CompanyID: companyID,
      };

      const resCreditSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: creditSettingsData,
        })
      );
      const debitSettingsData = {
        EntryTypeCD: 'DebitInvoice',
        SerialNumber: 'DBN',
        SerialIsActive: 1,
        NextInvoiceNumber: 1,
        FinancialYearID: fyID,
        Prefix: 'DBN',
        Suffix: '',
        CompanyID: companyID,
      };

      const resDebitSettings = await API.graphql(
        graphqlOperation(createNumberTracker, {
          createNumberTrackerInput: debitSettingsData,
        })
      );
    } catch (error) {
      console.log('error', error);
    }
  }
  async function saveFinancialYear() {
    let endDate = '';
    let startDate = '';
    let SED = '';
    let FYID = '';
    let fYearData = {};
    SED = skipformElements.startendmonth.split(' ');
    startDate = new Date(SED[0] + '-' + SED[1] + '-' + new Date(skipformElements.fyStart).getFullYear());
    let syy = startDate.getFullYear();
    let smm = startDate.getMonth() + 1;
    let sdd = startDate.getDate();
    if (sdd < 10) sdd = '0' + sdd;
    if (smm < 10) smm = '0' + smm;
    let SD = syy + '-' + smm + '-' + sdd;
    endDate = new Date(SED[4] + '-' + SED[3] + '-' + new Date(skipformElements.fyEnd).getFullYear());
    let eyy = endDate.getFullYear();
    let emm = endDate.getMonth() + 1;
    let edd = endDate.getDate();
    if (edd < 10) edd = '0' + edd;
    if (smm < 10) emm = '0' + emm;
    let ED = eyy + '-' + emm + '-' + edd;

    fYearData = {
      AliasName: '',
      Comments: '',
      EndDate: Math.floor(new Date(ED).getTime() / 1000),
      EndYear: skipformElements.fyEnd.$y,
      StartDate: Math.floor(new Date(SD).getTime() / 1000),
      StartYear: skipformElements.fyStart.$y,
    };
    // })
    const resFYearData = await API.graphql(
      graphqlOperation(createFinancialYear, {
        createFinancialYearInput: fYearData,
      })
    );
    const userPreferenceData = {
      AdditionalValue: '',
      AttributeTypeCD: 'SelectedFinYear',
      AttributeValue: resFYearData.data.createFinancialYear.FinancialYearID,
    };
    const resUserPreferenceData = await API.graphql(
      graphqlOperation(createUserPreference, {
        createUserPreferenceInput: userPreferenceData,
      })
    );
  }
  async function saveCompanyDetails(compID) {
    try {
      const companyDetails = {};
      const res = await API.graphql(
        graphqlOperation(createCompanyDetails, {
          createCompanyDetailsInput: companyDetails,
        })
      );
      if (res?.data?.createCompanyDetails !== null) {
        showSuccessSnackbar('Company Created Successfully');
        dispatch(setCompanyName(res?.data?.createCompanyDetails?.CompanyShort));
        setOpen(false);
        setloading(false);
        dispatch(skipFalse());
        if (companyDetailsData === undefined || companyDetailsData === null) dispatch(fetchCompany());
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  console.log(Object.values(skipformElements.errorStatus).includes(true), 'Object.values(skipformElements.errorStatus).includes(true)');
  console.log(skipformElements, 'eeeeeee');
  async function saveChanges() {
    if (companyCreateInFlightRef.current) return;
    companyCreateInFlightRef.current = true;
    setloading(true);

    const {
      gstCategory,
      gstin,
      entityTYpe,
      legalname,
      country,
      state,
      address,
      fromDate,
      startendmonth,
      fyEnd,
      fyStart,
      mobile,
      pincode,
      pan,
      EInvoiceFlag,
    } = skipformElements;

    const SED = startendmonth.split(' ');
    const startDate = dayjs(`${SED[0]}-${SED[1]}-${dayjs(fyStart).year()}`).startOf('day');

    const endDate = dayjs(`${SED[4]}-${SED[3]}-${dayjs(fyEnd).year()}`).startOf('day');

    const SD = startDate.unix();
    const ED = endDate.unix();
    setFreezeInput(true);

    try {
      const { isvalid, firstErrorField } = formVaidation(skipformElements);
      if (isvalid) {
        setOpen(false);
        dispatch(setIsAnyModalOpen(false));
        const add = address.split(',');
        let stCode = state.slice(0, -8) || 0;
        let { email, phone_number: mobileNo } = await getUserAttributes();
        email = email ? email : '';

        const companyData = {
          CompanyName: legalname?.trim(),
          StartDate: SD,
          EndDate: ED,
          StartYear: dayjs(fyStart).year(),
          EndYear: dayjs(fyEnd).year(),
          Comments: '',
          AliasName: '',
          CompanyActive: companyDetailsData === undefined || companyDetailsData === null ? 1 : 0,
          CompanyShort: legalname?.trim(),
          LUTBondToDate: 0,
          InvoiceDetailApplicableFromDate: 0,
          TDSApplicable: 0,
          GSTCategory: gstCategory,
          FinancialYearStartAndEndMonth: 0,
          WebsiteURL: '',
          CurrencyCD: 0,
          AccountInventoryFlag: 0,
          PANNumber: pan,
          TDSTCSNumber: '',
          CINRegistrationNumber: '',
          RegistrationType: gstCategory == 'Unregistered' ? 1 : gstCategory == 'Registered' ? 2 : gstCategory == 'Composition' ? 3 : 4,
          GSTRPeriod: '',
          LUT: '',
          LUTBondValidFrom: 0,
          EwayBillFlag: 0,
          GSTApplicableFrom: fromDate
            ? dayjs(fromDate, ['YYYY-MM-DD', 'DD/MM/YYYY']).isValid()
              ? dayjs(fromDate, ['YYYY-MM-DD', 'DD/MM/YYYY']).startOf('day').unix()
              : 0
            : 0,
          ThresholdLimitCD: 0,
          ThresholdLimitAmount: 0,
          CompanyLogoUrl: '',
          MSMEType: '',
          UdhyamRegNo: '',
          UdhyamDocs: '',
          EwayBillStartDate: 0,
          MinAmountEwayInter: 0,
          MinAmountEwayIntra: 0,
          EInvoiceFlag: EInvoiceFlag,
          EInvoiceStartingDate: 0,
          GSTCompensationCessFlag: 0,
          TradeLicenseNumber: '',
          TradeLicenseStartDate: 0,
          TradeLicenseEndDate: 0,
          CINRegistrationDate: 0,
          Line1: add ? add.join('**') : '',
          StateCode: 0,
          CountryCode: '',
          EmailAddress: email,
          PhoneNumber: mobile || mobileNo,
          PinCode: pincode || '',
          GSTIN: gstin.length === 15 ? gstin : '',
        };
        const isSkip = false;
        await createNewCompany(companyData, isSkip);
      } else {
        setFreezeInput(false);
        if (firstErrorField) {
          setTimeout(() => focusFirstErrorField(firstErrorField), 100);
        }
      }
    } catch (e) {
      console.log(e, 'error');
      showWarningSnackbar('Something went wrong');
      setOpen(true);
    } finally {
      setFreezeInput(false);
      setloading(false);
      companyCreateInFlightRef.current = false;
    }
  }

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      // const companyData = {
      //   CompanyName: "",
      // };
      // const isSkip = true;
      // createNewCompany(companyData, isSkip);

      setOpen(false);
      dispatch(setIsAnyModalOpen(false));
      setOpenSkipModal(false);
      dispatch(skipFalse());
      // Keep BottomNavBar (useCompanySetupStatus) in sync even if this component unmounts immediately.
      localStorage.removeItem('companySetupOpen');
      window.dispatchEvent(new Event('companySetupChange'));
      setSkipFormElements({
        gstCategory: '',
        gstin: '',
        entityTYpe: '',
        legalname: '',
        state: '',
        country: '',
        address: '',
        fromDate: todayDate,
        startendmonth: '01 Apr - 31 Mar',
        fyStart: dayjs(currentDate),
        fyEnd: dayjs(currentDate).add(1, 'year'),
        selectedFy: '01 Apr' + ' ' + dayjs(currentDate).$y + ' ' + 'to' + ' ' + '31 Mar' + ' ' + dayjs(currentDate).add(1, 'year').$y,
        mobile: '',
        errorStatus: {
          gstCategory: false,
          gstin: false,
          entityTYpe: false,
          legalname: false,
          state: false,
          country: false,
          address: false,
          fromDate: false,
          startendmonth: false,
          fyStatrt: false,
          fyEnd: false,
          selectedFy: false,
          mobile: false,
        },
        errorFields: {
          gstCategory: '',
          gstin: '',
          entityTYpe: '',
          legalname: '',
          state: '',
          country: '',
          address: '',
          fromDate: '',
          startendmonth: '',
          fyStatrt: '',
          fyEnd: '',
          selectedFy: '',
          mobile: '',
        },
      });
      setOpenSkipModal(false);
      // dispatch(skipNotSave());
    }
  };
  console.log(skipformElements, 'skipformElements');

  function handleChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    const id = e.target.id;
    console.log(value, 'ddddddddddddddddd');

    if (value === '') {
      setSkipFormElements((prev) => ({
        ...prev,
        [name]: value,
        ['errorStatus']: {
          ...prev.errorStatus,
          [name]: true,
        },
        ['errorFields']: {
          ...prev.errorFields,
          [name]: id + ' is required',
        },
      }));
    } else if (GST_CATEGORIES_REQUIRING_GSTIN.includes(value)) {
      setSkipFormElements((prev) => ({
        ...prev,
        [name]: value,
        errorStatus: {
          ...prev.errorStatus,
          ['gstin']: true,
          [name]: false,
        },
        ['errorFields']: {
          ...prev.errorFields,
          ['gstin']: 'GSTIN is required',
          [name]: '',
        },
      }));
    } else {
      setSkipFormElements((prev) => ({
        ...prev,
        [name]: value,
        ['errorStatus']: {
          ...prev.errorStatus,
          [name]: false,
          ['gstin']: false,
        },
        ['errorFields']: {
          ...prev.errorFields,
          [name]: '',
          ['gstin']: '',
        },
      }));
    }

    // setSkipFormElements((prev) => ({
    //   ...prev,
    //   [name]: value,
    // }));
  }

  function formVaidation(data) {
    let isvalid = true;
    let obj = { ...skipformElements };

    Object.keys(data).map((itemKey) => {
      // if(itemKey === 'gstCategory'){
      //     if(data[itemKey].trim().length <= 0){
      //         isvalid=false;
      //         obj.errorFields.gstCategory='GST Category is required'
      //         obj.errorStatus.gstCategory = true
      //     } else {
      //         obj.errorFields.gstCategory=''
      //         obj.errorStatus.gstCategory = false
      //     }
      // }
      // console.log('skipformElements',skipformElements);
      // if (itemKey === 'gstin') {
      //   if (skipformElements.gstCategory != "Unregistered") {
      //     console.log('calledd :::::::::;;; gst category');
      //     if (data[itemKey].trim().length <= 0) {
      //       isvalid = false;
      //       obj.errorFields.gstin = 'GSTIN is required'
      //       obj.errorStatus.gstin = true
      //     } else if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(data[itemKey])) {
      //       isvalid = false;
      //       obj.errorFields.gstin = 'Invalid GSTIN Number'
      //       obj.errorStatus.gstin = true
      //     } else {
      //       obj.errorFields.gstin = ''
      //       obj.errorStatus.gstin = false
      //     }
      //   }
      // }

      // if(itemKey === 'entityTYpe'){
      //     if(data[itemKey].trim().length <= 0){
      //         isvalid=false;
      //         obj.errorFields.entityTYpe='Entity Type is required'
      //         obj.errorStatus.entityTYpe = true
      //     } else {
      //         obj.errorFields.entityTYpe=''
      //         obj.errorStatus.entityTYpe = false
      //     }
      // }
      if (itemKey === 'gstin') {
        const gstinValue = (data[itemKey] || '').trim();
        const category = (data.gstCategory || '').trim();
        const needsGstin = GST_CATEGORIES_REQUIRING_GSTIN.includes(category);

        if (needsGstin) {
          if (!gstinValue) {
            isvalid = false;
            obj.errorFields[itemKey] = 'GSTIN is required';
            obj.errorStatus[itemKey] = true;
          } else if (!GSTIN_FORMAT_REGEX.test(gstinValue)) {
            isvalid = false;
            obj.errorFields[itemKey] = 'Invalid GSTIN Format';
            obj.errorStatus[itemKey] = true;
          } else {
            obj.errorFields[itemKey] = '';
            obj.errorStatus[itemKey] = false;
          }
        } else if (!GSTIN_FORMAT_REGEX.test(gstinValue) && gstinValue !== '') {
          isvalid = false;
          obj.errorFields[itemKey] = 'Invalid GSTIN Format';
          obj.errorStatus[itemKey] = true;
        } else {
          obj.errorFields[itemKey] = '';
          obj.errorStatus[itemKey] = false;
        }
      }
      if (itemKey === 'gstCategory') {
        if (data[itemKey].length <= 0) {
          isvalid = false;
          obj.errorFields[itemKey] = 'GST Category is  required';
          obj.errorStatus[itemKey] = true;
        }
      }
      if (itemKey === 'legalname') {
        if (
          // !/^[a-zA-Z0-9_& -]*$/.test(data[itemKey])
          !/^[a-zA-Z0-9.&' @_",()/-]*$/.test(data[itemKey]) &&
          data?.[itemKey]?.trim()?.length > 0
        ) {
          isvalid = false;
          obj.errorFields.legalname = 'Company Legal Name is Invalid';
          obj.errorStatus.legalname = true;
        } else if (data?.[itemKey]?.trim().length <= 0) {
          isvalid = false;
          obj.errorFields.legalname = 'Legal Name is  required';
          obj.errorStatus.legalname = true;
        } else if (data?.[itemKey]?.trim().length > 0) {
          const existingCompany = companyList.filter((obj) => obj.CompanyShort?.toLowerCase() === data[itemKey]?.trim()?.toLowerCase());
          if (existingCompany.length > 0) {
            isvalid = false;
            obj.errorFields.legalname = 'Company Legal Name already exists';
            obj.errorStatus.legalname = true;
          }
        } else {
          obj.errorFields.legalname = '';
          obj.errorStatus.legalname = false;
        }
      }

      // if(itemKey === 'country'){
      //     if(data[itemKey].trim().length <= 0){
      //         isvalid=false;
      //         obj.errorFields.country='Country is required'
      //         obj.errorStatus.country = true
      //     } else {
      //         obj.errorFields.country=''
      //         obj.errorStatus.country = false
      //     }
      // }

      // if(itemKey === 'state'){
      //     if(data[itemKey].trim().length <= 0){
      //         isvalid=false;
      //         obj.errorFields.state='State is required'
      //         obj.errorStatus.state = true
      //     } else {
      //         obj.errorFields.state=''
      //         obj.errorStatus.state = false
      //     }
      // }

      // if(itemKey === 'address'){
      //     if(data[itemKey].trim().length <= 0){
      //         isvalid=false;
      //         obj.errorFields.address='Comapny Address is required'
      //         obj.errorStatus.address = true
      //     } else {
      //         obj.errorFields.address=''
      //         obj.errorStatus.address = false
      //     }
      // }
      if (itemKey === 'mobile') {
        if (data?.[itemKey]?.trim().length > 0) {
          if (data?.[itemKey] === '+91') {
            isvalid = false;
            obj.errorFields.mobile = 'Mobile Number is  required';
            obj.errorStatus.mobile = true;
          } else if (!matchIsValidTel(data?.[itemKey])) {
            isvalid = false;
            obj.errorFields.mobile = 'Mobile Number is Invalid';
            obj.errorStatus.mobile = true;
          } else {
            obj.errorFields.mobile = '';
            obj.errorStatus.mobile = false;
          }
        } else {
          isvalid = false;
          obj.errorFields.mobile = 'Mobile Number is  required';
          obj.errorStatus.mobile = true;
        }
      }
      if (itemKey === 'fromDate') {
        if (data?.[itemKey]?.trim().length <= 0) {
          isvalid = false;
          obj.errorFields.fromDate = 'Booking Start Date is required';
          obj.errorStatus.fromDate = true;
        } else {
          obj.errorFields.fromDate = '';
          obj.errorStatus.fromDate = false;
        }
      }
      // if(itemKey === 'startendmonth'){
      //     if(data[itemKey].trim().length <= 0){
      //         isvalid=false;
      //         obj.errorFields.startendmonth='Financial Year Month is required'
      //         obj.errorStatus.startendmonth = true
      //     } else {
      //         obj.errorFields.startendmonth=''
      //         obj.errorStatus.startendmonth = false
      //     }
      // }
    });
    console.log(skipformElements, 'skipformElements');
    setSkipFormElements(obj);
    const firstErrorField = isvalid ? null : (ERROR_FIELD_FOCUS_ORDER.find((key) => obj.errorStatus[key] === true) ?? null);
    return { isvalid, firstErrorField };
  }
  const [gstORpan, setgstORpan] = useState();
  const [backdropOpen, setBackdropOpen] = useState();

  // Function to capitalize first letter of each word
  const capitalizeWords = (str) => {
    if (!str) return str;
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const validateInputForGstPan = async (value) => {
    const gstinRegex = GSTIN_FORMAT_REGEX; // GSTIN format
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // PAN format
    setBackdropOpen(true);
    // const updateErrorState = (hasError, message = '') => {
    //   setSkipFormElements((prev) => ({
    //     ...prev,
    //     errorStatus: {
    //       ...prev.errorStatus,
    //       gstin: hasError,
    //     },
    //     errorFields: {
    //       ...prev.errorFields,
    //       gstin: message,
    //     },
    //   }));
    // };

    try {
      if (value.length === 15 && gstinRegex.test(value)) {
        setgstORpan('GSTIN');
        // updateErrorState(false);

        const res = await FetchGstInDetails(value);
        const fetchedPan =
          res?.data?.Pan ||
          res?.data?.PAN ||
          res?.data?.pan ||
          value?.substring(2, 12) ||
          '';

        console.log(res?.data?.TaxPayerType, '====>tresponse');
        setSkipFormElements((prev) => ({
          ...prev,
          errorStatus: {
            ...prev.errorStatus,
            gstin: false,
            gstCategory: false,
            legalname: false,
          },
          errorFields: {
            ...prev.errorFields,
            gstin: '',
            gstCategory: '',
            legalname: '',
          },
          gstCategory:
            res?.data?.TaxPayerType?.toLowerCase().includes('sez') === true
              ? 'SEZ'
              : res?.data?.TaxPayerType == 'Regular'
                ? 'Registered'
                : res?.data?.TaxPayerType == 'Composition'
                  ? 'Composition'
                  : '',
          state: res?.data?.Address?.State || '',
          pincode: res?.data?.Address?.PinCode || '',
          legalname: res?.data?.TradeName || res?.data?.LegalName || '',
          address: res?.data?.AddressLine1 ? res?.data?.AddressLine1 + ',' + res?.data?.AddressLine2 : '',
          fromDate: res?.data?.RegisteredDate,
          EInvoiceFlag: res?.data?.EinvoiceStatus == 'Yes' ? 1 : 0,
          city: res?.data?.Address?.Location || '',
          pan: prev?.pan?.trim() ? prev.pan : fetchedPan,
        }));
      } else {
        setgstORpan('');
        setSkipFormElements((prev) => ({
          ...prev,
          errorStatus: {
            ...prev.errorStatus,
            gstCategory: false,
            legalname: false,
          },
          errorFields: {
            ...prev.errorFields,
            gstCategory: '',
            legalname: '',
          },

          state: '',
          pincode: '',
          address: '',
          EInvoiceFlag: 0,
          city: '',
        }));
        // updateErrorState(false);
      }
      // else if (value.length === 10 && panRegex.test(value)) {
      // setgstORpan('PAN');
      // updateErrorState(false);
      // }
      // else if (value.length >= 10) {
      //   setgstORpan("");
      //   setSkipFormElements((prev) => ({
      //     ...prev,
      //     gstCategory: "",
      //     state: "",
      //     pincode: "",
      //     legalname: "",
      //     address: "",
      //     fromDate: todayDate,
      //     EInvoiceFlag: 0,
      //     city: "",
      //   }));
      //   updateErrorState(true, "Invalid GSTIN or PAN format.");
      // }
    } catch (error) {
      console.error('Error fetching GSTIN details:', error);
      if (error?.code === 'F08000' || error?.code === 'SWEB_9035') {
        showWarningSnackbar('Invalid GSTIN as per GST Portal');
        setSkipFormElements((prev) => ({
          ...prev,
          errorStatus: {
            ...prev.errorStatus,
            gstin: false,
          },
          errorFields: {
            ...prev.errorFields,
            gstin: 'Invalid GSTIN',
          },
        }));
      } else if (error?.code === 'ERR_NETWORK') {
        showWarningSnackbar('Network error. Please check your internet connection');
        setSkipFormElements((prev) => ({
          ...prev,
          errorStatus: {
            ...prev.errorStatus,
            gstin: false,
          },
          errorFields: {
            ...prev.errorFields,
            gstin: '',
          },
        }));
      } else {
        showWarningSnackbar('GSTIN Portal is currently unavailable. Unable to validate or fetch details. Please enter details manually');
        setSkipFormElements((prev) => ({
          ...prev,
          errorStatus: {
            ...prev.errorStatus,
            gstin: false,
          },
          errorFields: {
            ...prev.errorFields,
            gstin: '',
          },
        }));
      }
    } finally {
      console.log('Validation complete.');
      setBackdropOpen(false);
    }
  };

  const handleChangeforGstPan = (e) => {
    const { value } = e.target;
    const gstinValue = value.trim().toUpperCase();
    const gstinRegex = GSTIN_FORMAT_REGEX;
    if (gstinValue.length === 0) {
      setSkipFormElements((prev) => ({
        ...prev,
        gstin: gstinValue,
        errorStatus: {
          ...prev.errorStatus,
          gstin: false,
        },
        errorFields: {
          ...prev.errorFields,
          gstin: '',
        },
      }));
    } else if (gstinValue.length === 15) {
      if (gstinRegex.test(gstinValue)) {
        setSkipFormElements((prev) => ({
          ...prev,
          gstin: gstinValue,
          errorStatus: {
            ...prev.errorStatus,
            gstin: false,
          },
          errorFields: {
            ...prev.errorFields,
            gstin: '',
          },
        }));
      } else {
        setSkipFormElements((prev) => ({
          ...prev,
          gstin: gstinValue,
          errorStatus: {
            ...prev.errorStatus,
            gstin: true,
          },
          errorFields: {
            ...prev.errorFields,
            gstin: 'Invalid GSTIN Format',
          },
        }));
      }
    } else {
      setSkipFormElements((prev) => ({
        ...prev,
        gstin: gstinValue,
        errorStatus: {
          ...prev.errorStatus,
          gstin: false,
        },
        errorFields: {
          ...prev.errorFields,
          gstin: '',
        },
      }));
    }
    if (gstinValue.length === 15 && gstinRegex.test(gstinValue)) {
      validateInputForGstPan(gstinValue);
    }
  };

  const handleBlurforGstPan = (e) => {
    const gstinValue = (e.target.value || '').trim().toUpperCase();
    if (!gstinValue) return;

    if (gstinValue.length !== 15 || !GSTIN_FORMAT_REGEX.test(gstinValue)) {
      setSkipFormElements((prev) => ({
        ...prev,
        gstin: gstinValue,
        errorStatus: {
          ...prev.errorStatus,
          gstin: true,
        },
        errorFields: {
          ...prev.errorFields,
          gstin: 'Invalid GSTIN Format',
        },
      }));
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e?.key?.toLowerCase() === 's') {
        e.preventDefault();
        saveChanges();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [skipformElements]);

  useEffect(() => {
    if (open) {
      localStorage.setItem('companySetupOpen', 'true');
    } else {
      localStorage.removeItem('companySetupOpen');
    }

    window.dispatchEvent(new Event('companySetupChange'));
  }, [open]);

  useEffect(() => {
    if (open) {
      dispatch(setIsAnyModalOpen(true));
    } else {
      dispatch(setIsAnyModalOpen(false));
    }
  }, [open]);

  useEffect(() => {
    // Safety: if modal component unmounts while open, clear the flag.
    return () => {
      localStorage.removeItem('companySetupOpen');
      window.dispatchEvent(new Event('companySetupChange'));
    };
  }, []);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onFoc
      id={open ? 'companySetup' : ''}
      // onClose={showWarningSnackbar("It's mandetory to complete your setup")}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          if (newCompanyCreation) {
            return handleClose();
          }
          showWarningSnackbar("It's mandetory to complete your setup");
        }
      }}
      closeAfterTransition
      // disableBackdropClick
      // BackdropComponent={Backdrop}
      // BackdropProps={{
      //   timeout: 500,
      // }}
    >
      <Fade in={open}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '15px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <GuidedNav props={'close'} ref={childRef} />

            <Box sx={{ flex: 1 }}>
              {newCompanyCreation ? (
                <Typography sx={{ color: '#fff' }}>Add New Company</Typography>
              ) : (
                <Typography sx={{ color: '#fff' }}>Complete Your Setup</Typography>
              )}
            </Box>
          </Box>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box
            sx={{
              padding: { md: '15px', xs: '8px' },
              // display : "flex",
              // flexDirection : "row"
              height: { xs: '425px', sm: 'auto' },
              overflowY: { xs: 'scroll', sm: 'hidden' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: { sm: 'flex-start' },
                flexWrap: { xs: 'wrap', md: 'nowrap' },
                flexDirection: { xs: 'column', sm: 'row' },
                marginBottom: '0px',
              }}
            >
              <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                <TextField
                  id="field-gstin"
                  name="gstin"
                  disabled={freezeInput}
                  size="small"
                  label={gstORpan || 'GSTIN'}
                  placeholder="Enter your GSTIN to auto-fill your profile"
                  value={skipformElements.gstin.trim().toUpperCase()}
                  error={skipformElements.errorStatus.gstin}
                  required={GST_CATEGORIES_REQUIRING_GSTIN.includes(skipformElements.gstCategory)}
                  inputProps={{ maxLength: 15 }}
                  onChange={(e) => {
                    handleChangeforGstPan(e);
                  }}
                  onBlur={handleBlurforGstPan}
                  sx={{
                    width: '100%',
                    '& .MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    },
                    '& .MuiInputBase-input::placeholder': {
                      // width:"100%",
                      fontSize: '12px',
                      // overflow:"hidden",
                      // textOverflow:"ellipsis"
                    },
                  }}
                  InputLabelProps={{
                    shrink: true, // Prevents label from shrinking
                  }}
                />
                <Typography
                  sx={{
                    marginTop: '2px',
                    marginLeft: '10px',
                    marginBottom: '0px',
                    fontSize: '11px',
                    color: 'danger.main',
                  }}
                >
                  {skipformElements?.errorFields.gstin}
                </Typography>
              </Box>
              <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                <SelectField
                  disable={freezeInput}
                  name="gstCategory"
                  placeholder="GST Category"
                  size="small"
                  state={skipformElements}
                  // required={skipformElements.gstCategory ? false : true}
                  required={true}
                  onChange={(e) => handleChange(e)}
                  value={skipformElements.gstCategory}
                  options={[
                    { option: 'Unregistered-business/Individual', value: 'Unregistered' },
                    { option: 'Registered Business - Regular', value: 'Registered' },
                    { option: 'Registered Business - Composition Scheme', value: 'Composition' },
                    // { option: 'SEZ', value: 'SEZ' },
                  ]}
                  sx={{
                    '.MuiInputBase-input ': {
                      padding: '5px 10px',
                      // minWidth: "240px",
                      minHeight: '20px',
                    },
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    },
                  }}
                />
              </Box>

              {/* {skipformElements.gstCategory != 'Unregistered' && (
                <Box sx={{ flex: { xs: 1, sm: .5 }, m: 1 }}>
                  <InputField
                    name='gstin'
                    placeholder='GSTIN'
                    size='small'
                    type='text'
                    state={skipformElements}
                    // onChange={(e) => handleChange(e)}
                    value={skipformElements.gstin}
                    onChange={(e) => {
                      const name = e.target.name
                      const value = e.target.value

                      if (value == '') {
                        setSkipFormElements((prev) => ({
                          ...prev,
                          [name]: value,
                          ['errorStatus']: {
                            ...prev.errorStatus,
                            [name]: true
                          },
                          ['errorFields']: {
                            ...prev.errorFields,
                            [name]: 'GSTIN is required'
                          }
                        }))
                      } else {
                        if (!new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/).test(value)) {
                          setSkipFormElements((prev) => ({
                            ...prev,
                            [name]: value,
                            ['errorStatus']: {
                              ...prev.errorStatus,
                              [name]: true
                            },
                            ['errorFields']: {
                              ...prev.errorFields,
                              [name]: 'Invalid GSTIN Number'
                            }
                          }))
                        } else {
                          setSkipFormElements((prev) => ({
                            ...prev,
                            [name]: value,
                            ['errorStatus']: {
                              ...prev.errorStatus,
                              [name]: false
                            },
                            ['errorFields']: {
                              ...prev.errorFields,
                              [name]: ''
                            }
                          }))
                        }
                      }
                    }}
                  />
                </Box>)} */}
              {/* <Box sx={{ flex: { xs: 1, sm: .5 }, m: 1 }}>
                                <SelectField
                                    name='entityTYpe'
                                    placeholder='Entity Type'
                                    size='small'
                                    state={skipformElements}
                                    onChange={(e) => handleChange(e)}
                                    value={skipformElements.entityTYpe}
                                    options={[
                                        { value: '1', option: 'Individual' },
                                        { value: '2', option: 'Proprietorship' },
                                        { value: '3', option: 'Partnership' },
                                        { value: '4', option: 'LLP' },
                                        { value: '5', option: 'Company' },
                                        { value: '6', option: 'Trust' },
                                        { value: '7', option: 'Others' },
                                    ]}
                                />
                            </Box> */}
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: { sm: 'flex-start' },
                flexWrap: { xs: 'wrap', md: 'nowrap' },
                flexDirection: { xs: 'column', sm: 'row' },
                m: 0,
              }}
            >
              <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                <InputField
                  disable={freezeInput}
                  id="companyName"
                  name="legalname"
                  placeholder="Company Legal Name"
                  size="small"
                  type="text"
                  inputProps={{ maxLength: 70 }}
                  required={skipformElements.legalname ? false : true}
                  state={skipformElements}
                  // onBlur={(e) => {
                  //   if (e.target.value) {
                  //     const existingCompany = companyList.filter(
                  //       (obj) => obj.CompanyShort.toLowerCase() === e.target?.value.trim().toLowerCase()
                  //     );
                  //     if (existingCompany.length > 0) {
                  //       setSkipFormElements((prev) => ({
                  //         ...prev,
                  //         ['legalname']: e.target.value,
                  //         ['errorStatus']: {
                  //           ...prev.errorStatus,
                  //           ['legalname']: true,
                  //         },
                  //         ['errorFields']: {
                  //           ...prev.errorFields,
                  //           ['legalname']: 'Company Legal Name already exists',
                  //         },
                  //       }));
                  //     } else {
                  //       setSkipFormElements((prev) => ({
                  //         ...prev,
                  //         ['legalname']: e.target.value,
                  //         ['errorStatus']: {
                  //           ...prev.errorStatus,
                  //           ['legalname']: false,
                  //         },
                  //         ['errorFields']: {
                  //           ...prev.errorFields,
                  //           ['legalname']: '',
                  //         },
                  //       }));
                  //     }
                  //   }
                  // }}
                  // onChange={(e) => handleChange(e)}
                  value={skipformElements.legalname}
                  onChange={(e) => {
                    const name = e.target.name;
                    const value = e.target.value;
                    const capitalizedValue = capitalizeWords(value);

                    if (value === '') {
                      // Case: empty
                      setSkipFormElements((prev) => ({
                        ...prev,
                        [name]: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          [name]: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          [name]: 'Legal Name is required',
                        },
                      }));
                    } else if (/^[a-zA-Z0-9.&'@_",()/-\s]*$/.test(value)) {
                      // Case: valid — update value with capitalization, clear error

                      setSkipFormElements((prev) => ({
                        ...prev,
                        [name]: capitalizedValue,
                        errorStatus: {
                          ...prev.errorStatus,
                          [name]: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          [name]: '',
                        },
                      }));
                    } else {
                      // Case: invalid — show error
                      setSkipFormElements((prev) => ({
                        ...prev,
                        [name]: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          [name]: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          [name]: 'Company Legal Name is invalid',
                        },
                      }));
                    }
                  }}
                />
              </Box>
              <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                <CustomPhoneInputBox
                  name="mobile"
                  label="Mobile"
                  size="small"
                  type="text"
                  defaultCountry="IN"
                  disable={freezeInput}
                  focusOnSelectCountry={true}
                  forceCallingCode={true}
                  required={true}
                  onChange={(newPhone) => {
                    if (newPhone === '+91') {
                      setSkipFormElements((prev) => ({
                        ...prev,
                        ['mobile']: newPhone,
                        ['errorStatus']: {
                          ...prev.errorStatus,
                          ['mobile']: true,
                        },
                        ['errorFields']: {
                          ...prev.errorFields,
                          ['mobile']: 'Mobile Number is required',
                        },
                      }));
                    } else {
                      if (!matchIsValidTel(newPhone)) {
                        setSkipFormElements((prev) => ({
                          ...prev,
                          ['mobile']: newPhone,
                          ['errorStatus']: {
                            ...prev.errorStatus,
                            ['mobile']: true,
                          },
                          ['errorFields']: {
                            ...prev.errorFields,
                            ['mobile']: 'Mobile Number is Invalid',
                          },
                        }));
                      } else {
                        setSkipFormElements((prev) => ({
                          ...prev,
                          ['mobile']: newPhone,
                          ['errorStatus']: {
                            ...prev.errorStatus,
                            ['mobile']: false,
                          },
                          ['errorFields']: {
                            ...prev.errorFields,
                            ['mobile']: '',
                          },
                        }));
                      }
                    }
                  }}
                  state={skipformElements}
                  value={skipformElements.mobile}
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: { sm: 'center' },
                flexWrap: { xs: 'wrap', md: 'nowrap' },
                flexDirection: { xs: 'column', sm: 'row' },
                marginBottom: '0px',
              }}
            >
              <Box sx={{ flex: { xs: 1, sm: 0.33 }, m: 1 }}>
                <TextField
                  select
                  name="startendmonth"
                  label="Financial Year Start & End Month"
                  size="small"
                  fullWidth
                  disabled={freezeInput}
                  id="finantialYear"
                  value={skipformElements.startendmonth}
                  onChange={(e) => {
                    const value = e.target.value;
                    setStartEndYearValue(value);
                    let SED = value.split(' ');

                    if (value !== '') {
                      if (!isNaN(skipformElements.fyStart.$y)) {
                        if (value == '01 Jan - 31 Dec') {
                          setSkipFormElements((prev) => ({
                            ...prev,
                            fyStart: dayjs(),
                            fyEnd: dayjs(),
                            selectedFy:
                              SED[0] + ' ' + SED[1] + ' ' + dayjs().$y + ' ' + 'to' + ' ' + SED[3] + ' ' + SED[4] + ' ' + dayjs().$y,
                          }));
                        } else {
                          setSkipFormElements((prev) => ({
                            ...prev,
                            fyEnd: dayjs(skipformElements.fyStart).add(1, 'year'),
                            selectedFy:
                              SED[0] +
                              ' ' +
                              SED[1] +
                              ' ' +
                              dayjs(skipformElements.fyStart).$y +
                              ' ' +
                              'to' +
                              ' ' +
                              SED[3] +
                              ' ' +
                              SED[4] +
                              ' ' +
                              dayjs(skipformElements.fyStart).add(1, 'year').$y,
                          }));
                        }
                      }
                    } else {
                      if (value == '01 Jan - 31 Dec') {
                        setSkipFormElements((prev) => ({
                          ...prev,
                          fyEnd: ' ',
                          selectedFy: SED[0] + ' ' + SED[1] + ' ' + ' ' + ' ' + 'to' + ' ' + SED[3] + ' ' + SED[4] + ' ' + ' ',
                        }));
                      } else {
                        setSkipFormElements((prev) => ({
                          ...prev,
                          fyEnd: dayjs(skipformElements.fyStart).add(1, 'year'),
                          selectedFy: SED[0] + ' ' + SED[1] + ' ' + ' ' + ' ' + 'to' + ' ' + SED[3] + ' ' + SED[4] + ' ' + ' ',
                        }));
                      }
                    }
                    setSkipFormElements((prev) => ({
                      ...prev,
                      startendmonth: value,
                    }));
                  }}
                  sx={{
                    '.MuiSelect-select': {
                      fontSize: '12px',
                    },
                    '.MuiTypography-root': {
                      fontSize: '12px',
                    },
                    '.MuiInputBase-input ': {
                      fontSize: '12px',
                      padding: '4px 10px',
                      // minWidth: "240px",
                      minHeight: '20px',
                    },
                    width: '100%',
                  }}
                >
                  {finacialYearsOptions.map((item, ind) => {
                    return (
                      <MenuItem key={item.value} value={`${item.value}`}>
                        <ListItemText primary={item.option} />
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Box>
              <Box
                onKeyDown={(e) => {
                  if (e.shiftKey && e.key == 'Tab') {
                    e.preventDefault();
                    document.getElementById('finantialYear').focus();
                  } else if (e.key == 'Tab') {
                    if (document.getElementById('cancel')) document.getElementById('cancel')?.focus();
                    if (document.getElementById('save')) document.getElementById('save').focus();
                  }
                }}
                sx={{ flex: { xs: 1, sm: 0.33 }, m: 1 }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    error={false}
                    size="small"
                    label={'FY Starting'}
                    views={['year']}
                    name="fYStart"
                    required={true}
                    disabled={freezeInput}
                    minDate={dayjs('1990-01-01')}
                    maxDate={dayjs('2036-12-31')}
                    value={dayjs(skipformElements.fyStart)}
                    onChange={(year) => {
                      let SED = startEndYearValue.split(' ');
                      setSkipFormElements((prev) => ({
                        ...prev,
                        fyStart: dayjs(year),
                      }));
                      if (skipformElements.startendmonth != '') {
                        let endYear = dayjs(year).add(1, 'year').$y;
                        if (year != null) {
                          if (startEndYearValue == '01 Jan - 31 Dec') {
                            setSkipFormElements((prev) => ({
                              ...prev,
                              fyStart: dayjs(year),
                              fyEnd: dayjs(year),
                              selectedFy: SED[0] + ' ' + SED[1] + ' ' + year.$y + ' ' + 'to' + ' ' + SED[3] + ' ' + SED[4] + ' ' + year.$y,
                            }));
                          } else {
                            SED = skipformElements.startendmonth.split(' ');

                            setSkipFormElements((prev) => ({
                              ...prev,
                              fyEnd: dayjs(year).add(1, 'year'),
                              selectedFy: SED[0] + ' ' + SED[1] + ' ' + year.$y + ' ' + 'to' + ' ' + SED[3] + ' ' + SED[4] + ' ' + endYear,
                            }));
                          }
                        } else {
                          if (startEndYearValue == '01 Jan - 31 Dec') {
                            setSkipFormElements((prev) => ({
                              ...prev,
                              fyStart: dayjs(),
                              fyEnd: dayjs(),
                              selectedFy:
                                SED[0] + ' ' + SED[1] + ' ' + dayjs().$y + ' ' + 'to' + ' ' + SED[3] + ' ' + SED[4] + ' ' + dayjs().$y,
                            }));
                          } else {
                            SED = skipformElements.startendmonth.split(' ');
                            setSkipFormElements((prev) => ({
                              ...prev,
                              fyStart: dayjs(),
                              fyEnd: dayjs().add(1, 'year'),
                              selectedFy:
                                SED[0] +
                                ' ' +
                                SED[1] +
                                ' ' +
                                dayjs().$y +
                                ' ' +
                                'to' +
                                ' ' +
                                SED[3] +
                                ' ' +
                                SED[4] +
                                ' ' +
                                dayjs().add(1, 'year').$y,
                            }));
                          }
                        }
                      }
                    }}
                    sx={{
                      '.MuiInputBase-input ': {
                        padding: '8px 10px',
                        // minWidth: "240px",
                        minHeight: '20px',
                      },
                      width: '100%',
                    }}
                    renderInput={(params) => (
                      // <TextField
                      //   error={false}
                      //   required={true}
                      //   {...params}
                      //   helperText={null}
                      // />
                      <TextField
                        {...params}
                        required={true}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <IconButton
                              sx={{
                                p: 0.5,
                                '& .MuiSvgIcon-root': {
                                  fontSize: '1rem',
                                },
                              }}
                            >
                              <CalendarToday />
                            </IconButton>
                          ),
                        }}
                      />
                    )}
                    slotProps={{
                      textField: {
                        onKeyDown: (event) => event.preventDefault(),
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ flex: { xs: 1, sm: 0.33 }, m: 1 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    error={false}
                    size="small"
                    label={'FY Ending'}
                    views={['year']}
                    name="fYEnd"
                    disabled={true}
                    required={true}
                    minDate={dayjs('1991-01-01')}
                    maxDate={dayjs('2038-12-31')}
                    value={dayjs(skipformElements.fyEnd)}
                    onChange={(year) => {
                      setSkipFormElements((prev) => ({
                        ...prev,
                        fyEnd: dayjs(year),
                      }));
                    }}
                    sx={{
                      '.MuiInputBase-input': {
                        padding: '8px 10px',
                        // minWidth: "240px",
                        minHeight: '20px',
                      },
                      '.MuiFormLabel-root-MuiInputLabel-root.Mui-error': {
                        color: 'input.label',
                      },
                      width: '100%',
                    }}
                    renderInput={(params) => (
                      // <TextField
                      //   required={true}
                      //   {...params}
                      //   helperText={null}
                      // />
                      <TextField
                        {...params}
                        required={true}
                        // onKeyDown={() => {
                        //   console.log(document.getElementById("cancel"))
                        // }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <IconButton
                              sx={{
                                p: 0.5,
                                '& .MuiSvgIcon-root': {
                                  fontSize: '1rem',
                                },
                              }}
                            >
                              <CalendarToday />
                            </IconButton>
                          ),
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: { sm: 'center' },
                flexWrap: { xs: 'wrap', md: 'nowrap' },
                flexDirection: { xs: 'column', sm: 'row' },
                marginBottom: '0px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: { xs: 1, sm: 1 },
                  m: 1,
                }}
              >
                <ErrorIcon color="info"></ErrorIcon>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: { xs: '13px', md: '15px' },
                    marginLeft: '5px',
                  }}
                >
                  Selected FY:
                  <Typography
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      fontWeight: 'bold',
                      fontSize: { xs: '13px', md: '15px' },
                      ml: 0.5,
                      color: 'danger.main',
                    }}
                  >
                    {skipformElements.selectedFy}
                  </Typography>
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              // padding : "15px",
              // width:'100%',
              display: 'flex',
              justifyContent: 'space-between',
              // flexDirection: { xs: "column", sm: "row" },
            }}
          >
            {newCompanyCreation && (
              <Button
                id="cancel"
                disableRipple={false}
                disabled={loading}
                onClick={handleClose}
                variant="outlined"
                sx={{ flex: 1, margin: '20px', fontSize: '12px' }}
              >
                Cancel
              </Button>
            )}
            {/* <Button onClick={saveChanges} variant='contained' sx={{ flex: 1, margin: '10px', fontSize: "12px" }} >Save</Button> */}
            <LoadingButton
              id="save"
              sx={{ flex: 1, margin: '20px', fontSize: '12px', backgroundColor: '#EE5B2B', '&:hover': { backgroundColor: '#EE5B2B' } }}
              data-gtm="company-setup-details-save"
              loading={loading}
              disableRipple={false}
              variant="contained"
              onClick={saveChanges}
            >
              Save
            </LoadingButton>
          </Box>
          <Backdrop sx={{ position: 'fixed', color: '#fff', zIndex: '13000' }} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default CompanySetupSkip;
